import { getBrowserWidth } from 'owa-mail-store-actions';
import { getUserConfiguration } from 'owa-session-store';
import { ReadingPanePosition } from 'owa-reading-pane-option';
import shouldCenterSearchBox from './shouldCenterSearchBox';
/**
 * Browser widths above this threshold means the search box width will be based
 * on browser width instead of a fixed value.
 */
var DYNAMIC_WIDTH_THRESHOLD = 1366;
/**
 * If the browser width is under DYNAMIC_WIDTH_THRESHOLD, the search box width
 * will be this value.
 */
var SMALL_SCREEN_SEARCHBOX_WIDTH = 468;
/**
 * If the browser width is equal to or greater than DYNAMIC_WIDTH_THRESHOLD, the
 * search box width will be this percentage of the user's browser width.
 */
var DYNAMIC_WIDTH_MODIFIER = 0.45;
export default function getNewSearchBoxWidth() {
    /**
     * If the centered search box treatment is enabled, the logic is different
     * (relies on browser width instead of component widths).
     */
    if (shouldCenterSearchBox()) {
        var browserWidth = getBrowserWidth();
        /**
         * If browser width is < DYNAMIC_WIDTH_THRESHOLD, then the width of the
         * search box will be SMALL_SCREEN_SEARCHBOX_WIDTH.
         *
         * If browser width is >= DYNAMIC_WIDTH_THRESHOLD, then the width of the
         * search box will be DYNAMIC_WIDTH_MODIFIER percent of browser width.
         */
        if (browserWidth < DYNAMIC_WIDTH_THRESHOLD) {
            return SMALL_SCREEN_SEARCHBOX_WIDTH;
        }
        else {
            return browserWidth * DYNAMIC_WIDTH_MODIFIER;
        }
    }
    var userConfiguration = getUserConfiguration();
    // Gets the width of message list, if available.
    var globalFolderViewState = JSON.parse(userConfiguration.ViewStateConfiguration.GlobalFolderViewState || '{}');
    // Determines if the user is in 3 column view.
    var isReadingPanePositionRight = userConfiguration.UserOptions.GlobalReadingPanePositionReact === ReadingPanePosition.Right;
    /**
     * If the user is in 3 column view, the max width of the search box should
     * match the width of the message list. Otherwise, we use the default in owa-search.
     */
    return isReadingPanePositionRight ? globalFolderViewState.Width : null;
}
//# sourceMappingURL=getNewSearchBoxWidth.js.map